// extracted by mini-css-extract-plugin
export default {"logos":"sponsors_logos__oDTR+"};